(function(){
    const $ = (s, el=document)=>el.querySelector(s);
    const $$ = (s, el=document)=>Array.from(el.querySelectorAll(s));
  
    function findCardRoot(el){ return el.closest('.cp-card'); }
  
    function readVariantsJSON(card){
      const el = $('.cp-variants-json', card);
      try { return JSON.parse(el?.textContent || '[]'); } catch(e){ return []; }
    }
  
    function getColorIndex(variant, product){
      // infer via options array — cor costuma ser option1; não precisamos do índice exato aqui
      return 0;
    }
  
    function filterSizesByColor(card, colorName){
      const variants = readVariantsJSON(card);
      // supondo color na option[0]; se não for, o backend pode ajustar depois
      const byColor = variants.filter(v => (v.options?.[0] || '').toLowerCase() === colorName.toLowerCase());
      return byColor;
    }
  
    function mountSizes(card, colorName){
      const container = $('.cp-sizes', card);
      if(!container) return;
      container.innerHTML = '';
      const list = filterSizesByColor(card, colorName);
      // extrair nome do tamanho pela última option (comum: option2/option3)
      list.forEach(v=>{
        const opts = v.options || [];
        const size = opts[opts.length-1] || v.title;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cp-size-btn';
        btn.textContent = size;
        if(!v.available) btn.disabled = true;
        btn.dataset.variantId = String(v.id);
        btn.addEventListener('click', ()=> addToCart(card, v.id));
        container.appendChild(btn);
      });
      return list;
    }
  
    async function addToCart(card, variantId){
      try{
        const res = await fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        });
        if(!res.ok) throw new Error('Falha ao adicionar no carrinho');
        // Aqui você pode disparar evento p/ abrir o cart-drawer
        card.dispatchEvent(new CustomEvent('cp:added',{bubbles:true,detail:{variantId}}));
      }catch(e){
        console.error(e);
      }
    }
  
    function onSwatchChange(e){
      const input = e.target;
      if(!input.classList.contains('cp-swatch__input')) return;
      const card = findCardRoot(input);
      if(!card) return;
      const color = input.value;
      // montar/atualizar tamanhos
      const sizes = mountSizes(card, color);
      // se hover habilitado e existir imagem por variante, você pode trocar a imagem principal aqui no futuro
      // por enquanto usamos featured_media do produto; ajuste se necessário
    }
  
    function toggleSizes(e){
      const btn = e.target.closest('.cp-bag');
      if(!btn) return;
      const card = findCardRoot(btn);
      const panel = $('.cp-sizes', card);
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      if(expanded){
        btn.setAttribute('aria-expanded','false');
        panel.hidden = true;
        return;
      }
      // abrir
      btn.setAttribute('aria-expanded','true');
      panel.hidden = false;
  
      // garantir que exista cor selecionada
      const current = $('.cp-swatch__input:checked', card) || $('.cp-swatch__input', card);
      if(current){
        current.checked = true;
        mountSizes(card, current.value);
      }
    }
  
    // alternância de coleções
    function mountTabs(tabsEl){
      const sectionId = tabsEl.dataset.section;
      const tabs = $$('.fcp-tab', tabsEl);
      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.tab;
          tabs.forEach(t => t.classList.toggle('is-active', t === tab));
          $$('[data-collection-block]', document).forEach(block => {
            if(block.closest('[data-instance="' + sectionId + '"]')){
              block.hidden = block.dataset.collectionBlock !== target;
              if(!block.hidden) mountCarousel(block);
            }
          });
        });
      });
    }

    // carrossel simples (scroll horizontal)
    function mountCarousel(block){
      const track = $('.fcp-track', block);
      const prev = $('[data-prev]', block);
      const next = $('[data-next]', block);
      if(!track || !track.classList.contains('is-carousel')) return;
      const step = () => Math.round(track.clientWidth * 0.9);
      prev && prev.addEventListener('click', ()=> track.scrollBy({left: -step(), behavior: 'smooth'}));
      next && next.addEventListener('click', ()=> track.scrollBy({left:  step(), behavior: 'smooth'}));
    }
  
    // Inicialização
    document.addEventListener('change', onSwatchChange);
    document.addEventListener('click', toggleSizes);
    $$('.fcp-tabs').forEach(mountTabs);
    $$('.fcp-block').forEach(mountCarousel);
  })();
  